import React, { useEffect, useState } from 'react';
import { motion, Variants } from "motion/react";
import useDebounce from './hooks/useDebounce';

// Site
export const SiteTransitions: Variants = {
    initial: { opacity: 0 },
    animate: { opacity: 1, transition: { duration: 1 } },
    exit: { opacity: 0, transition: { duration: .7 } }
}

export const PageTransitions: Variants = {
    initial: { opacity: 0 },
    animate: { opacity: 1, transition: { duration: 1 } },
    exit: { opacity: 0, transition: { duration: 2 } }
}

export const BounceTransitions: Variants = {
    initial: { opacity: 0, x: -200, transition: { ease: 'easeOut' } },
    animate: { opacity: 1, x: 0, transition: { duration: .15, ease: 'easeOut' } },
    exit: { opacity: 0, x: 200, transition: { duration: .1, ease: 'easeIn' } }
}

interface BounceTransitionsProps {
    children: any,
    delay?: number
}

export const BounceTransitionWrap: React.FC<BounceTransitionsProps> = ({ children, delay = 0 }) => {
    const [triggerStagger, setTriggerStagger] = useState(false);
    const [variant, setVariant] = useState(delay ? 'initial' : 'animate');

    useDebounce(() => {
        if (!triggerStagger) return;
        setVariant('animate');
    }, delay * 1000, [triggerStagger])

    useEffect(() => {
        if (delay) setTriggerStagger(true);
    }, [])

    return (
        <motion.div
            layout
            variants={BounceTransitions}
            initial='initial'
            animate={variant}
            exit='exit'
            className='contents'
        >
            {children}
        </motion.div>
    )
}

export const CarouselTransitions: Variants = {
    initial: { x: -25, opacity: 0, transition: { duration: 1 } },
    animate: { x: 0, opacity: 1, transition: { duration: 1 } },
    exit: { x: 25, opacity: 0, transition: { duration: 1 } }
}

export default null;